// extracted by mini-css-extract-plugin
export default {"main":"layoutSmall_main__rTKvd","bigLogo":"layoutSmall_bigLogo__NImx7"};